// extracted by mini-css-extract-plugin
export default {"importWordsForm":"ImportWordsForm_importWordsForm__pNohx","textarea":"ImportWordsForm_textarea__Z9rHP"};